
    import './styles.scoped.css';
    export default {
  "column-layout": "awsui_column-layout_vj6p7_1q1xl_99",
  "grid": "awsui_grid_vj6p7_1q1xl_134",
  "grid-no-gutters": "awsui_grid-no-gutters_vj6p7_1q1xl_140",
  "grid-variant-text-grid": "awsui_grid-variant-text-grid_vj6p7_1q1xl_144",
  "grid-breakpoint-default": "awsui_grid-breakpoint-default_vj6p7_1q1xl_152",
  "grid-columns-1": "awsui_grid-columns-1_vj6p7_1q1xl_155",
  "grid-breakpoint-xxs": "awsui_grid-breakpoint-xxs_vj6p7_1q1xl_155",
  "grid-breakpoint-xs": "awsui_grid-breakpoint-xs_vj6p7_1q1xl_158",
  "grid-columns-2": "awsui_grid-columns-2_vj6p7_1q1xl_161",
  "grid-columns-3": "awsui_grid-columns-3_vj6p7_1q1xl_167",
  "grid-columns-4": "awsui_grid-columns-4_vj6p7_1q1xl_173",
  "grid-vertical-borders": "awsui_grid-vertical-borders_vj6p7_1q1xl_189",
  "grid-horizontal-borders": "awsui_grid-horizontal-borders_vj6p7_1q1xl_222",
  "root": "awsui_root_vj6p7_1q1xl_276",
  "tile-container": "awsui_tile-container_vj6p7_1q1xl_314",
  "refresh": "awsui_refresh_vj6p7_1q1xl_329",
  "has-metadata": "awsui_has-metadata_vj6p7_1q1xl_333",
  "selected": "awsui_selected_vj6p7_1q1xl_339",
  "disabled": "awsui_disabled_vj6p7_1q1xl_344",
  "columns": "awsui_columns_vj6p7_1q1xl_360",
  "column-1": "awsui_column-1_vj6p7_1q1xl_366",
  "breakpoint-xs": "awsui_breakpoint-xs_vj6p7_1q1xl_373",
  "breakpoint-xxs": "awsui_breakpoint-xxs_vj6p7_1q1xl_377",
  "column-2": "awsui_column-2_vj6p7_1q1xl_381",
  "column-3": "awsui_column-3_vj6p7_1q1xl_396",
  "column-4": "awsui_column-4_vj6p7_1q1xl_411",
  "control": "awsui_control_vj6p7_1q1xl_427",
  "no-image": "awsui_no-image_vj6p7_1q1xl_431",
  "image": "awsui_image_vj6p7_1q1xl_435"
};
  